import React from 'react';
import classNames from 'classnames';
import { Colors } from '@oy/uicore';

import styles from './Dot.module.css';

export type DotProps = {
  color: Colors;
  size: number;
  maxSize?: number;
  children: string | React.ReactNode;
};

const Dot = ({ color, size, maxSize, children }: DotProps) => {
  return (
    <div
      className={styles.container}
      style={{ width: maxSize ?? size, height: maxSize ?? size }}
    >
      <div
        className={classNames(styles.container, styles.circle)}
        style={{ width: size, height: size, backgroundColor: color }}
      >
        {children}
      </div>
    </div>
  );
};

Dot.Color = Colors;

export default Dot;
